import React, { useEffect,useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteProgram, fetchPrograms } from "../../redux/actions/programActions"; 
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { PiTextColumnsLight } from "react-icons/pi";
import { TbStars } from "react-icons/tb";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import DeletePopup from "../../Components/DeletePopup";
import EditProgramPopup from "./EditProgramPopup";
import PageComponent from "../../Components/PageComponent";

function AllPrograms() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Redux state selectors
  const { data: programs, loading, error } = useSelector(
    (state) => state.program.programs
  );

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false); // State for Edit Modal
  const [selectedProgram, setSelectedProgram] = useState(null); // Store the selected program

  useEffect(() => {
    dispatch(fetchPrograms()); // Fetch programs when the component mounts
  }, [dispatch]);

  const handleDelete = (program) => {
    setSelectedProgram(program); // Set the selected program for deletion
    setIsDeleteOpen(true); // Open the delete popup
  };

  const handleDeleteConfirm = () => {
      if (selectedProgram) {
        dispatch(deleteProgram(selectedProgram.id));
        alert(`Program ${selectedProgram.program_name} has been deleted.`); 
        setIsDeleteOpen(false);
      }
    };

  const handleEdit = (program) => {
    setSelectedProgram(program); // Set the selected program for editing
    setIsEditOpen(true); // Open the edit modal
  };

  return (
    <>
    <PageComponent>
    <div className="flex w-screen h-screen bg-[#F8F7FA] overflow-hidden">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 min-h-screen p-6 ml-64 overflow-auto">
        {/* Page Title */}
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">International Section</span>
        </div>

        {/* Buttons */}
        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/international/addProgram")
            }
          >
            <TbStars className="mr-2" />
            Add Program
          </button>
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() =>
              navigate("/academics&international/international/allPrograms")
            }
          >
            <PiTextColumnsLight className="mr-2" />
            All Programs
          </button>
        </div>

        {/* Add/Edit Degree Form */}
        <div className="w-full p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="mb-4 text-xl font-semibold text-gray-700">Programme List</h2>

          {/* Registered Degrees Table */}
          <div className="overflow-x-auto max-h-96 sidebar-container">
            {loading ? (
              <p>Loading...</p>
            )  : (
              <table className="min-w-full border-collapse table-auto">
                <thead>
                  <tr className="text-left text-gray-600 bg-gray-100">
                    <th className="px-8 py-2 whitespace-nowrap">PROGRAMME NAME</th>
                    <th className="px-8 py-2 whitespace-nowrap">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {programs.map((program) => (
                    <tr
                      key={program.id}
                      className="border-b border-gray-300"
                    >
                      <td className="px-8 py-2">{program.program_name}</td>
                      <td className="flex items-center justify-start px-2 py-2 gap-x-2">
                        <button
                          type="button"
                          className="flex items-center px-5 py-1 text-gray-400 bg-gray-100 border border-gray-400 rounded"
                          onClick={() => handleDelete(program)}
                        >
                          Delete
                          <MdOutlineDeleteForever className="w-5 h-5 ml-2" />
                        </button>
                        <button
                          type="button"
                          className="flex items-center px-5 py-1 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                          onClick={() => handleEdit(program)}
                        >
                          Edit
                          <FaRegEdit className="w-4 h-4 ml-2" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Delete Confirmation Popup */}
        <DeletePopup
  title="program"
  isOpen={isDeleteOpen}
  onClose={() => setIsDeleteOpen(false)}
  onConfirm={handleDeleteConfirm}
  data={
    selectedProgram?.program_name || ""
  }
/>

        {/* Edit Program Modal */}
        <EditProgramPopup
          isOpen={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          onSave={(updatedProgram) => {
            console.log("Updated Program:", updatedProgram);
            setIsEditOpen(false);
          }}
          programData={selectedProgram || {}}
        />
      </div>
    </div>
    </PageComponent>
    </>
  );
}

export default AllPrograms;
